// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4577 ? "2b7b2d2a" : chunkId) + "." + {"35":"54f4943954531dcb","780":"ac82bfae0541297e","895":"1d26a7b754853291","1297":"b6d047ad9c39f26f","2353":"915a8f056bd922b6","4113":"a05e9aa93fd790d5","4577":"655f81c3fb9c8f97","6115":"223b8d2065e01918","8175":"1798793c0992d032"}[chunkId] + ".js";
};